import { Repository } from '../../../core/context/repository';
import { type Asset } from './entity';

export class Assets extends Repository<Asset> {
    getByZoneId(zoneId: string): Asset[] {
        return this.items.filter((asset) => asset.zoneId === zoneId);
    }

    getInScope(): Asset[] {
        return this.items.filter((asset) => asset.inScope);
    }
}
